import type { JSX, ReactElement } from "react";

interface VerbDef {
  readonly key: string;
  readonly label: string;
  readonly icon: ReactElement;
}

const STROKE_PROPS = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

function OfficersIcon(): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <g {...STROKE_PROPS}>
        <circle cx="12" cy="8" r="3.4" />
        <path d="M5.5 20.5 C 6.5 16 9 14.5 12 14.5 C 15 14.5 17.5 16 18.5 20.5" />
        <path d="M9.2 5.5 L12 2.5 L14.8 5.5" />
      </g>
    </svg>
  );
}

function UnitsIcon(): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <g {...STROKE_PROPS}>
        <path d="M12 3.5 L20.5 19 L3.5 19 Z" />
        <path d="M12 9 L12 15" />
        <circle cx="12" cy="17" r="0.6" fill="currentColor" stroke="none" />
      </g>
    </svg>
  );
}

function InventoryIcon(): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <g {...STROKE_PROPS}>
        <path d="M3.5 8.5 L12 3.5 L20.5 8.5 L20.5 15.5 L12 20.5 L3.5 15.5 Z" />
        <path d="M3.5 8.5 L12 13 L20.5 8.5" />
        <path d="M12 13 L12 20.5" />
      </g>
    </svg>
  );
}

function AllianceIcon(): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <g {...STROKE_PROPS}>
        <path d="M12 3 L19.8 7.5 L19.8 14.5 C 19.8 18 16.2 20.5 12 21.5 C 7.8 20.5 4.2 18 4.2 14.5 L4.2 7.5 Z" />
        <path d="M9 12.5 L11.2 14.7 L15.2 10.5" />
      </g>
    </svg>
  );
}

function ArmyIcon(): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <g {...STROKE_PROPS}>
        <path d="M3.5 20.5 L13 11 L17 7 L20.5 3.5" />
        <path d="M14.5 8 L20.5 3.5 L19 5" />
        <path d="M20.5 20.5 L11 11 L7 7 L3.5 3.5" />
        <path d="M9.5 8 L3.5 3.5 L5 5" />
      </g>
    </svg>
  );
}

const VERBS: ReadonlyArray<VerbDef> = [
  { key: "officers", label: "Officers", icon: <OfficersIcon /> },
  { key: "units", label: "Units", icon: <UnitsIcon /> },
  { key: "inventory", label: "Inventory", icon: <InventoryIcon /> },
  { key: "alliance", label: "Alliance", icon: <AllianceIcon /> },
  { key: "army", label: "Army", icon: <ArmyIcon /> },
];

export function BottomBar(): JSX.Element {
  return (
    <nav className="bottom-bar" aria-label="Primary actions">
      {VERBS.map((v) => (
        <button
          key={v.key}
          type="button"
          className="verb"
          disabled
          aria-disabled="true"
          aria-label={`${v.label} — available after Phase 1`}
          tabIndex={-1}
        >
          <span className="verb-icon" aria-hidden="true">
            {v.icon}
          </span>
          {v.label}
        </button>
      ))}
    </nav>
  );
}
